import { List, Map, fromJS } from 'immutable';

export function request(state, { id }) {
    let audits = state.get('collections') || Map()
    audits =  [...audits].filter(([k, v]) => k !== id);
    state = state.set('collections', new Map(audits));

    return state;
}
